<template>
  <div class="social-container">
    <div class="container-content">
      <table cellspacing = 0 cellpadding = 0>
      <tr class="table-header">
        <th class="job">职位名称</th>
        <th>职位类别</th>
        <th>发布时间</th>
        <th>工作地点</th>
        <th>详情</th>
      </tr>
      <tr class="table-body">
        <td class="job"><img src="../../../../assets/logo/组 318.png" alt="" class="content-logo1">Web前端工程师</td>
        <td>软件开发</td>
        <td>2022-03-31</td>
        <td>合肥蜀山</td>
        <td><router-link to="" class="spical-a">查看</router-link></td>
      </tr>  
      <tr class="table-body">
        <td class="job"><img src="../../../../assets/logo/路径 283.png" alt="" class="content-logo2">Java开发工程师</td>
        <td>软件开发</td>
        <td>2022-03-31</td>
        <td>合肥蜀山</td>
        <td><router-link to="" class="spical-a">查看</router-link></td>
      </tr> 
       <tr class="table-body">
        <td class="job"><img src="../../../../assets/logo/组 319.png" alt="" class="content-logo3">软件项目经理</td>
        <td>经理</td>
        <td>2022-03-31</td>
        <td>合肥蜀山</td>
        <td><router-link to="" class="spical-a">查看</router-link></td>
      </tr> 
      <tr class="table-body">
        <td class="job"><img src="../../../../assets/logo/组 319.png" alt="" class="content-logo3">UI设计师</td>
        <td>设计</td>
        <td>2022-03-31</td>
        <td>合肥蜀山</td>
        <td><router-link to="" class="spical-a">查看</router-link></td>
      </tr> 
      <tr class="table-body">
        <td class="job"><img src="../../../../assets/logo/组 322.png" alt="" class="content-logo4">软件测试</td>
        <td>测试</td>
        <td>2022-03-31</td>
        <td>合肥蜀山</td>
        <td><router-link to="/join/social_software" class="spical-a">查看</router-link></td>
      </tr> 
      <tr class="table-body">
        <td class="job"><img src="../../../../assets/logo/组 323.png" alt="" class="content-logo4">互联网运营</td>
        <td>运营</td>
        <td>2022-03-31</td>
        <td>合肥蜀山</td>
        <td><router-link to="" class="spical-a">查看</router-link></td>
      </tr> 
      </table>
    </div>
    <div class="crumbs-nav">
      <svg t="1647833705034" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3680" width="0.2rem" height="0.2rem"><path d="M938.412716 480.847489 556.823881 104.126522c-1.89721-2.258437-6.142907-6.194072-12.037151-10.081613-9.920954-6.544043-21.162995-10.520611-33.496905-10.520611-13.180184 0-24.690332 3.997034-34.357506 10.623965-5.846148 4.010337-9.876951 8.102538-12.157901 11.154038L84.209914 480.894561c-14.700817 14.481829-14.700817 38.014802 0 52.529377 14.585183 14.427594 33.995255 8.343015 50.529837-7.945973l25.607214-25.314549 38.918381-37.700647c-1.359974 1.686409-2.282996 2.963495-2.284019 3.373841L196.981327 847.484797c0 50.006927 40.941458 90.427522 91.442642 90.427522l141.713582 0 10.423397 0L440.560948 927.486876 440.560948 686.440961c0-17.467837 14.411221-31.683607 32.223912-31.683607l77.051887 0c17.814738 0 32.223912 14.21577 32.223912 31.683607L582.060659 927.486876l0 10.425444 10.425444 0 141.713582 0c50.485835 0 91.442642-40.428781 91.442642-90.427522L825.642327 467.251843l62.246693 61.207014c20.142759 13.266142 37.897122 17.434068 50.523697 4.963035C953.114556 518.910387 953.114556 495.361041 938.412716 480.847489z" p-id="3681" fill="#c6c6c6"></path></svg>
      <div class="crumbs-text1" @click="goToHome">首页</div>
      <div class="crumbs-text2" @click="goToJoin">加入我们</div>
      <div class="crumbs-text3">校园招聘</div>
      <img src="../../../../assets/images/路径 93.png" alt="" class="crumbs-img1" @click="goToHome">
      <img src="../../../../assets/images/路径 94.png" alt="" class="crumbs-img2" @click="goToJoin">
      <img src="../../../../assets/images/路径 95.png" alt="" class="crumbs-img3">
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '@/componets/footer/Footer'
export default {
  components: {
    Footer,
  },
  methods: {
    goToHome() {
      this.$router.push('/home')
    },
    goToJoin () {
      this.$router.back()
    }
  },
}
</script>

<style lang="less" scoped>
.social-container {
  width: 19.2rem;
  font-size: 0.22rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  position: relative;
}
.container-content {
  width: 12rem;
  height: 5.6rem;
  margin: 0.9rem auto 1.1rem auto;
  // background-color: #F6F8FC;
}
table {
  width: 12rem;
  height: 5.6rem;
  text-align: left;
  border: 0.01rem solid #EDF1F5;
}
.table-header {
  color: #788497;
  background-color: #F6F8FC ;
  font-size: 0.22rem;
  font-weight: 500;
  line-height: 0.33rem;
}
table td {
font-size: 0.22rem;
font-weight: 400;
line-height: 0.33rem;
color: #666666;
border-top: 0.01rem solid #EDF1F5;
}
table a {
  text-decoration: none;
  color: #0078FF;
}
.spical-a {
  color: #BCBCBC;
}
.job {
  padding-left: 0.4rem;
  box-sizing: border-box;
  text-align: left;
}
//logo的大小
.content-logo1{
  width: 0.21rem;
  height: 0.18rem;
  display: inline-block;
  margin-right: 0.11rem;
}
.content-logo2{
  width: 0.18rem;
  height: 0.24rem;
  display: inline-block;
  margin-right: 0.11rem;
}
.content-logo3{
  width: 0.19rem;
  height: 0.21rem;
  display: inline-block;
  margin-right: 0.11rem;
}
.content-logo4{
  width: 0.2rem;
  height: 0.19rem;
  display: inline-block;
  margin-right: 0.11rem;
}
//蓝色的面包屑导航
.crumbs-nav {
  width: 6rem;
  height: 0.6rem;
  font-size: 0.16rem;
  position: relative;
  position: absolute;
  top: -1.2rem;
  left: 2.6rem;
}
.crumbs-nav img {
  cursor: pointer;
}
.icon {
  position: absolute;
  top: 0.18rem;
  left: 0.41rem;
  z-index: 99;
}
.crumbs-text1 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 0.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text2 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 1.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text3 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 3.14rem;
  color: #FFFFFF;
  z-index: 99;
}
.crumbs-img1 {
  width: 1.45rem;
  height: 0.6rem;
  position: absolute;
  left: 0;
  z-index: 2;
}
.crumbs-img2 {
  width: 2.04rem;
  height: 0.6rem;
  position: absolute;
  left: 0.72rem;
  z-index: 1;
}
.crumbs-img3 {
  width: 2.07rem;
  height: 0.6rem;
  position: absolute;
  left: 2.17rem;
}
</style>